import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import {
  deleteAccount,
  getAccount,
  getMonthlyIndustryRevenueReport,
  getMonthlyPlanRevenueReport,
  getPackageRevenueReport,
  getpackageselect,
  packageReport,
} from "../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../Utils/restUtils";
import { Add } from "../../Constant";
import SearchList from "../../CommonElements/Search";
import Transparentspinner from "../Common/loader/Transparentspinner";
import IndustryFilter from "../Common/Filters/IndustryFilter";
import { monthOptions } from "../../Constant/DropdownValue";

const MonthlyRevenueByPlan = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const currentYear = new Date().getFullYear();
  const [packData, setPackData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [packageOptions, setPackageOptions] = useState([]);
  const [isIndustry, setIsIndustry] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedYear, setSelectedYear] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [pieData, setPieData] = useState([]);
  const [prevPieData, setPrevPieData] = useState([]);
  const [prevPieLabels, setPrevPieLabels] = useState([]);
  const [pieLabels, setPieLabels] = useState([]);
  const revenuColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Sl,
      sortable: true,
      width: "80px",
      center:true
    },
    {
      name: <H4>Package Name</H4>,
      selector: (row) => row.PackageName,
      sortable: true,
      wrap: true,
      minWidth: "160px",
      maxWidth: "200px",
    },
    {
      name: <H4>Industry Name</H4>,
      selector: (row) => row.IndustryName,
      sortable: true,
      wrap: true,
      minWidth: "160px",
      maxWidth: "200px",
    },
    {
      name: <H4>January</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.January}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>February</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.February}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>March</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.March}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>April</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.April}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>May</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.May}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>June</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.June}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>July</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.July}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>August</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.August}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>September</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.September}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>October</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.October}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>November</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.November}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <H4>December</H4>,
      selector: (row) => (
        <span className="fw-bolder billerq_color">₹ {row.December}</span>
      ),
      sortable: true,
      width: "120px",
    },
  ];

  useEffect(() => {
    packageData(1, perPage, {});
    getPieChartData({});
    getPreviousMonthPieChartData({});
  }, []);
  useEffect(() => {
    setSelectedPackage("");
    loadPackages(isIndustry);
  }, [isIndustry]);

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    packageData(page, perPage, appliedFilters);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    packageData(page, newPerPage, appliedFilters);
  };
  const getPieChartData = async (filters = {}) => {
    try {
      const query = new URLSearchParams({
        industry_type_id: filters.industry_type_id || "",
        package_id: filters.package_id || "",
        year: filters.year || "",
        month: filters.month || "",
      }).toString();

      const res = await getDataWithToken(
        `${getPackageRevenueReport}?type=pie&${query}`,
      );

      const apiData = res?.data || [];
      console.log("apiData", apiData);

      const values = apiData.map((item) => item.total_revenue || 0);
      const labels = apiData.map((item) => item.package_name || "Unknown");

      setPieData(values);
      setPieLabels(labels);
    } catch (err) {
      console.log(err);
      setPieData([]);
      setPieLabels([]);
    }
  };
  const getPreviousMonthPieChartData = async (filters = {}) => {
    try {
      const query = new URLSearchParams({
        industry_type_id: filters.industry_type_id || "",
        package_id: filters.package_id || "",
        year: filters.year || "",
        month: filters.month || "",
        previous_month: 1,
      }).toString();

      const res = await getDataWithToken(
        `${getPackageRevenueReport}?type=pie&${query}`,
      );

      const apiData = res?.data || [];

      const values = apiData.map((item) => item.total_revenue || 0);
      const labels = apiData.map((item) => item.package_name || "Unknown");

      setPrevPieData(values);
      setPrevPieLabels(labels);
    } catch (err) {
      console.log(err);
      setPrevPieData([]);
      setPrevPieLabels([]);
    }
  };
  const commonPieOptions = (labels) => ({
    labels,
    legend: {
      position: "bottom",
    },
    plotOptions: {
      pie: {
        customScale: 0.9,
      },
    },
  });
  const chartContainerStyle = {
    width: "100%",
    height: "320px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const handleFilter = () => {
    const filters = {
      search: tempSearch,
      industry_type_id: isIndustry?.value || "",
      package_id: selectedPackage || "",
      year: selectedYear || "",
      month: selectedMonth || "",
    };

    setAppliedFilters(filters);
    setCurrentPage(1);

    packageData(1, perPage, filters);
    getPieChartData(filters);
    getPreviousMonthPieChartData(filters);
  };

  const getYearOption = () => {
    const startYear = 2022;
    const currentYear = new Date().getFullYear();
    const endYear = currentYear;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };

  const loadPackages = async (industryId) => {
    if (!industryId?.value) {
      setPackageOptions([]);
      setSelectedPackage("");
      return;
    }

    try {
      const res = await getDataWithToken(
        `${getpackageselect}?industry_type_id=${industryId.value}`,
      );
      if (res?.status === true && Array.isArray(res?.data)) {
        setPackageOptions(res.data);
      } else {
        setPackageOptions([]);
      }
    } catch (err) {
      setPackageOptions([]);
    }
  };
  const packageData = async (page = 1, size = perPage, filters = {}) => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        page_length: size,
        search: filters.search || "",
        industry_type_id: filters.industry_type_id || "",
        package_id: filters.package_id || "",
        year: filters.year || "",
        month: filters.month || "",
      }).toString();
      const res = await getDataWithToken(
        `${getMonthlyPlanRevenueReport}?${query}`,
      );

      const formattedData = res.data.data.map((e, index) => ({
        Sl: (page - 1) * size + index + 1,
        PackageName: e.package_name,
        IndustryName: e.industry_name,
        January: e.Jan,
        February: e.Feb,
        March: e.Mar,
        April: e.Apr,
        May: e.May,
        June: e.Jun,
        July: e.Jul,
        August: e.Aug,
        September: e.Sep,
        October: e.Oct,
        November: e.Nov,
        December: e.Dec,
      }));

      setPackData(formattedData);
      setTotalRows(res.data.total || 0);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };
  const fetchExportData = async () => {
    const query = new URLSearchParams({
      export: "monthly_plan_revenue",
      search: appliedFilters.search || "",
      industry_type_id: appliedFilters.industry_type_id || "",
      package_id: appliedFilters.package_id || "",
      year: appliedFilters.year || "",
      month: appliedFilters.month || "",
    }).toString();

    const res = await getDataWithToken(
      `${getMonthlyPlanRevenueReport}?${query}`,
    );

    return res?.data || [];
  };
  const exportExcel = async () => {
    setLoading(true);
    try {
      const data = await fetchExportData();

      const formatted = data.map((e, index) => ({
        Sl: index + 1,
        Package: e.package_name,
        Industry: e.industry_name,
        January: e.Jan,
        February: e.Feb,
        March: e.Mar,
        April: e.Apr,
        May: e.May,
        June: e.Jun,
        July: e.Jul,
        August: e.Aug,
        September: e.Sep,
        October: e.Oct,
        November: e.Nov,
        December: e.Dec,
      }));

      const ws = XLSX.utils.json_to_sheet(formatted);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Plan Revenue");

      XLSX.writeFile(wb, "monthly_revenue_by_plan.xlsx");
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const exportPDF = async () => {
    setLoading(true);
    try {
      const data = await fetchExportData();

      const doc = new jsPDF("l", "mm", "a4");

      const rows = data.map((e, index) => [
        index + 1,
        e.package_name,
        e.industry_name,
        e.Jan,
        e.Feb,
        e.Mar,
        e.Apr,
        e.May,
        e.Jun,
        e.Jul,
        e.Aug,
        e.Sep,
        e.Oct,
        e.Nov,
        e.Dec,
      ]);

      autoTable(doc, {
        head: [
          [
            "Sl",
            "Package",
            "Industry",
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        ],
        body: rows,
        styles: { fontSize: 7 },
      });

      doc.save("monthly_revenue_by_plan.pdf");
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Monthly Revenue By Plan"
        parent="Report"
        title="Monthly Revenue By Plan"
      />
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <H3>Monthly Revenue By Plan Report</H3>

          <Dropdown
            isOpen={dropdownOpen}
            toggle={() => setDropdownOpen(!dropdownOpen)}
          >
            <DropdownToggle
              className="btn btn-primary"
              color="#fff"
              style={{ fontSize: "14px", zIndex: 1000 }}
            >
              Export <i className="icofont icofont-arrow-up"></i>
            </DropdownToggle>

            <DropdownMenu container="body">
              <DropdownItem onClick={exportExcel}>
                <i className="fa fa-file-excel-o me-2"></i> Excel
              </DropdownItem>

              <DropdownItem onClick={exportPDF}>
                <i className="fa fa-file-pdf-o me-2"></i> PDF
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          {/* <div style={{ display: "flex", alignItems: "center", float: "left" }}>
            <SearchList />
            <button className="btn btn-primary  mb-2 ms-2  ">Filter</button>
          </div> */}
          <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <select
                  className="form-select"
                  value={selectedPackage}
                  disabled={!isIndustry?.value}
                  style={
                    !isIndustry?.value
                      ? {
                          backgroundColor: "#f5f5f5",
                          color: "#999",
                        }
                      : {}
                  }
                  onChange={(e) => {
                    setSelectedPackage(e.target.value);
                  }}
                >
                  <option value="">
                    {isIndustry?.value
                      ? "All Packages"
                      : "Select Industry First"}
                  </option>

                  {packageOptions.map((pkg) => (
                    <option key={pkg.id} value={pkg.id}>
                      {pkg.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col m="12" md="6" lg="3">
                <select
                  className="form-select select-dashboard"
                  defaultValue={currentYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  {getYearOption().map((year) => {
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
              </Col>
              <Col
                sm="12"
                md="6"
                lg="3"
                className="d-flex align-items-center gap-2"
              >
                <select
                  className="form-select"
                  value={selectedMonth}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedMonth(value === "" ? "" : Number(value));
                  }}
                >
                  {monthOptions.map((m) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </select>

                <button className="btn btn-primary" onClick={handleFilter}>
                  Filter
                </button>
              </Col>
            </Row>
          </div>
          {/* <div style={{ float: "right" }}>
            <Link
              to={`${process.env.PUBLIC_URL}/configuration/account-add`}
              className="btn btn-primary"
            >
              {Add}
            </Link>
          </div> */}
          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <Row className="mb-4">
            {/* Previous Month */}
            <Col md="6">
              <Card>
                <CardHeader className="text-center">
                  <H4>Previous Month Revenue</H4>
                </CardHeader>
                <CardBody style={chartContainerStyle}>
                  {prevPieData.length > 0 ? (
                    <Chart
                      options={commonPieOptions(prevPieLabels)}
                      series={prevPieData}
                      type="pie"
                      width={300}
                      height={300}
                    />
                  ) : (
                    <p>No Data Available</p>
                  )}
                </CardBody>
              </Card>
            </Col>

            {/* Current Month */}
            <Col md="6">
              <Card>
                <CardHeader className="text-center">
                  <H4>Current Month Revenue</H4>
                </CardHeader>
                <CardBody style={chartContainerStyle}>
                  {pieData.length > 0 ? (
                    <Chart
                      options={commonPieOptions(pieLabels)}
                      series={pieData}
                      type="pie"
                      width={300}
                      height={300}
                    />
                  ) : (
                    <p>No Data Available</p>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div className="order-history table-responsive">
            <DataTable
              columns={revenuColumns}
              data={packData}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default MonthlyRevenueByPlan;
